<template>
  <div class="usercard" v-if="info">
    <div class="header">
      <table></table>
      <div class="flex jc-sb aic mt-15">
        <div class="flex aic ml-20">
          <div>
            <!-- <img :src="info.avatarPath | getavatar" alt="" /> -->
            <van-image :src="info.avatarPath | getavatar" class="avater" round>
              <template v-slot:error>
                <img src="../../assets/img/avater.png" class="avater" />
              </template>
            </van-image>
          </div>
          <div class="ml-25">
            <p class="name">{{info.alias?info.alias:info.nickName  }}</p>
            <p class="desc mt-5">{{ info.virtualJob }}</p>
          </div>
        </div>
        <div class="tac mr7" @click="showqrcode">
          <img src="../../assets/img/card/qs.png" class="qs" />
          <p class="f10 fff">点击加微信</p>
        </div>
      </div>
      <div class="tips1 flex fff f12 aic jc-sb">
        <div class="flex aic">
          <img src="../../assets/img/card/far fa-hospital Copy.svg" alt="" />
          <div style="font-weight: 500">
            中联信{{ info.dept.name }} | 从业{{ info.workingSeniority }}
          </div>
        </div>
        <div class="fff f12" style="font-weight: 400" @click="share">分享</div>
      </div>
      <div class="tips2 flex fff f12 aic jc-sb">
        <div class="flex aic">
          <img src="../../assets/img/card/md-phone_android Copy.svg" alt="" />
          <div style="font-weight: 500">{{ info.phone }}</div>
        </div>
        <a class="fff f12" :href="'tel:' + info.phone" style="font-weight: 400"
          >拨打</a
        >
      </div>
    </div>
    <div class="block flex jc-sb aic rel pb-25">
      <img
        class="userimg"
        v-if="number.length < 9"
        :style="{ left: 15 * index + 8 + 'px' }"
        v-for="(item, index) in number"
        :key="index"
        :src="item.avatarPath"
        alt=""
      />
      <img
        class="userimg"
        v-else
        :style="{ left: 15 * index + 8 + 'px' }"
        v-for="(item, index) in 8"
        :key="index"
        :src="number[index].avatarPath"
        alt=""
      />
      <div class="fg2 f14 w220 tar" style="color: rgba(16, 16, 16, 100)">
        {{
          number.length > 0 ? "最近有" + number.length + "人来过" : "还没人来过"
        }}
      </div>
    </div>
    <div class="block">
      <div
        class="f14"
        style="color: rgba(153, 159, 164, 100); font-weight: 500"
      >
        个人简介
      </div>
      <div class="f14 lh53 mt-10" style="color: #3b3f42">
        {{ info.synopsis }}
      </div>
    </div>
    <div class="block">
      <div class="flex jc-sb aic">
        <div
          class="f14"
          style="color: rgba(153, 159, 164, 100); font-weight: 500"
        >
          关于中联信
        </div>
        <img src="../../assets/img/card/logo.png" class="logo" />
      </div>
      <div class="f14 lh53 mt-10" style="color: #3b3f42">
        中联信成立于2011年6月，是一家全国性保险代理机构，注册资本5000万元，是北京保险服务中心的控股子公司。经过多年发展，公司形成了诚信、稳健、共创、共赢的经营策略，赢得了市场的认可与尊重。
      </div>
    </div>
    <div class="block">
      <div
        class="f18"
        style="font-family: SourceHanSansSC-bold; color: rgba(16, 16, 16, 100)"
      >
        Ta推荐的文章
      </div>

      <div v-for="(item, index) in list" :key="index">
        <van-divider />
        <div class="flex jc-sb aic" @click="toarticle(item)">
          <div>
            <div class="title">
              {{ item.title }}
            </div>
            <div class="flex jc-sb aic mt-10">
              <div class="btnr">{{ item.categoryName }}</div>
              <div
                style="color: rgba(153, 159, 164, 100)"
                class="f12 mr-5 flex aic"
              >
                <van-icon name="browsing-history" style="margin-right: 3px" />{{
                  item.times
                }}
              </div>
            </div>
          </div>
          <img class="poster" :src="item.coverImgUrl" alt="" />
        </div>
      </div>
      <div @click="getmore">
        <van-divider />
        <div class="downs fcc" v-if="!isfinished">
          查看更多
          <img src="../../assets/img/card/down.svg" alt="" />
        </div>
        <div class="downs fcc" v-else>已经到底了</div>
      </div>
    </div>
    <van-dialog v-model="show" title="长按识别微信二维码" width="260px">
      <img :src="info.qrCodeUrl" class="qrcode" />
    </van-dialog>
    <van-overlay :show="shareshow" @click="shareshow = false">
      <div class="wrapper">
        <img src="../../assets/img/card/tips.jpg" class="shareimg" />
      </div>
    </van-overlay>
  </div>
</template>
<script>
import {
  userinfo,
  wxSocial,
  readRecord,
  queryNumbers,
  getJsApiTicket,
} from "@/api/users";
import { customerexist } from "@/api/clients";
import { userArticlemy, articledetail } from "@/api/article";
import { getToken } from "@/utils/auth";
import Vue from "vue";
import { Overlay } from "vant";
import wx from "weixin-js-sdk";
import $ from "jquery";
Vue.use(Overlay);
export default {
  data() {
    return {
      info: "", //用户信息
      userId: "",
      startTime: "", //访问时间
      customerId: "", //客户id
      show: false, //弹框显示
      page: 0,
      isfinished: false,
      list: [],
      number: [],
      shareshow: false,
      isAndroid: "",
      id: "",
      timer: "",
    };
  },
  methods: {
    toarticle(item) {
      this.$router.push({
        path: "/articledetail",
        query: { articleId: item.id, userId: this.userId },
      });
    },
    // 获取个人信息
    getinfo() {
      userinfo(this.userId).then((res) => {
        this.info = res;
        this.getwx();
      });
    },
    // 微信授权登录
    checkAuthor() {
      this.author();
    },
    author() {
      console.log('微信授权')
      wxSocial({ requestUrl: this.$route.fullPath })
        .then((res) => {
          window.location.href = res;
        })
        .catch((res) => {
          console.log(res);
        });
    },
    getQueryString(name) {
      var reg = new RegExp("(^|&)" + name + "=([^&]*)(&|$)", "i");
      var r = window.location.search.substr(1).match(reg);
      if (r != null) return unescape(r[2]);
      return null;
    },
    // 访问人数
    getnum() {
      queryNumbers(this.userId).then((res) => {
        this.number = res;
      });
    },
    // 文章列表
    getarticle() {
      if (this.isfinished) return;
      let data = {
        page: this.page,
        size: 10,
        sort: "articleId,desc",
        userId: this.userId,
      };
      userArticlemy(data).then((res) => {
        console.log(res);
        if (res.content.length > 0) {
          res.content.map((item) => this.getdetail(item));
          if (res.content.length < 10) this.isfinished = true;
        } else {
          this.isfinished = true;
        }
      });
    },
    // 文章详情
    getdetail(id) {
      articledetail(id).then((res) => {
        this.list.push(res);
      });
    },
    getmore() {
      if (!this.isfinished) {
        this.page++;
        this.getarticle();
      } else {
        this.Toast("已经到底了");
      }
    },
    addrecord() {
      if (!this.customerId || this.customerId == "null" || getToken()) return;
      let time = new Date() * 1;
      let data = {
        customerId: this.customerId,
        duration: time - this.startTime,
        userId: this.userId,
        type: "visiting-card",
        enterTime: this.startTime,
        leaveTime: time,
        id: this.id,
      };
      this.startTime = time;
      // if (this.isAndroid) {

      readRecord(data).then((res) => {
        this.id = res.id;
        if (res.duration > 600000) {
          clearInterval(this.timer);
        }
      });
    },
    unloadHandler1() {
      this.addrecord();
    },
    // 分享
    share() {
      this.shareshow = true;
    },
    // 展示二维码
    showqrcode() {
      if (this.info.qrCodeUrl) {
        this.show = true;
      } else {
        this.Toast("该用户还没有二维码");
      }
    },
    getwx() {
      let that = this;
      const link = window.location.href.split("?")[0];
      // if (link !== window.location.href) {
      // 	window.location.href = link;
      // } //为了兼容iOS系统，否则有可能地址取值出现错误
      const url = window.location.href.split("#")[0];
      getJsApiTicket({
        link: url,
      }).then((res) => {
        // window.location.href=url+'#'+sessionStorage.getItem("url")
        wx.config({
          debug: false, // 开启调试模式
          appId: res.body.appid, // 必填，公众号的唯一标识
          timestamp: res.body.timestamp, // 必填，生成签名的时间戳
          nonceStr: res.body.nonceStr, // 必填，生成签名的随机串
          signature: res.body.signature, // 必填，签名
          jsApiList: [
            "updateAppMessageShareData", //自定义“分享给朋友”及“分享到QQ”按钮的分享内容
            "updateTimelineShareData", //自定义“分享到朋友圈”及“分享到QQ空间”按钮的分享内容
          ], // 必填，需要使用的JS接口列表
        });
      });
      wx.ready(function () {
        that.wxShareTimeline();
        // config信息验证后会执行ready方法，所有接口调用都必须在config接口获得结果之后，config是一个客户端的异步操作，所以如果需要在页面加载时就调用相关接口，则须把相关接口放在ready函数中调用来确保正确执行。对于用户触发时才调用的接口，则可以直接调用，不需要放在ready函数中。
      });
      wx.error((res) => {
        console.log(res);
      });
    },
    wxShareTimeline() {
      // 自定义“分享给朋友”及“分享到QQ”按钮的分享内容
    let {nickName,alias}=this.info
    let name=alias?alias:nickName
      wx.updateAppMessageShareData({
        title: name + "的保险微名片", // 分享标题
        desc: this.info.synopsis, // 分享描述
        link: window.location.href, // 分享链接，该链接域名或路径必须与当前页面对应的公众号JS安全域名一致
        imgUrl: this.getavater(this.info.avatarPath), // 分享图标
        success: () => {
          console.log(1132);
        },
      });
      wx.updateTimelineShareData({
        title: name + "的保险微名片", // 分享标题
        desc: this.info.synopsis, // 分享描述
        link: window.location.href, // 分享链接，该链接域名或路径必须与当前页面对应的公众号JS安全域名一致
        imgUrl: this.getavater(this.info.avatarPath), // 分享图标
        success: () => {},
      });
    },
    getavater(val) {
      if (val && val.indexOf("http") == -1) {
        if (val.indexOf("/avatar/") == -1) {
          return process.env.VUE_APP_URL + "/avatar/" + val;
        } else {
          return process.env.VUE_APP_URL + val.split("zlxadmin")[1];
        }
      } else {
        return val;
      }
    },
    setTimer() {
      if (this.customerId == "null" || getToken()) return;
      this.addrecord();
      if (this.timer) {
        clearInterval(this.timer);
        this.timer = setInterval(() => {
          this.addrecord();
        }, 60000);
      } else {
        this.timer = setInterval(() => {
          this.addrecord();
        }, 60000);
      }
    },
  },
  mounted() {
    let { userId, customerId } = this.$route.query;
    if (!customerId) {
      customerId = localStorage.getItem("customerId");
    } else {
      localStorage.setItem("customerId", customerId);
    }

    this.userId = userId;
    this.customerId = customerId;
    this.startTime = new Date() * 1;
    if (!customerId && !getToken()) {
      this.checkAuthor();
    } else if (customerId == "null" && !getToken()) {
      this.$router.push({ path: "/login" });
    } else {
      if (customerId != "null"&& !getToken()) {
        customerexist(customerId).then((res) => {
          console.log(typeof res,res)
          if (res == false) {
            console.log('校验客户')
            localStorage.removeItem('customerId')
            this.checkAuthor();
          }else{
            this.getinfo();
            this.getnum();
            this.getarticle();
            this.setTimer();
          }
        });
      }else{
            this.getinfo();
            this.getnum();
            this.getarticle();
            this.setTimer();
          }

      
    }
  },
  beforeDestroy() {
    if (getToken()) {
      sessionStorage.removeItem("url");
    }
    clearInterval(this.timer);
    // window.removeEventListener("pagehide", this.unloadHandler1);
    this.addrecord();
  },
};
</script>
<style lang="less" scoped>
.usercard {
  width: 100%;
  padding-bottom: 40px;
  .header {
    width: 100%;
    height: 179px;
    background-color: rgba(59, 63, 66, 100);
    .qs {
      width: 32px;
      height: 32px;
    }
    .avater {
      // img {
      width: 53px !important;
      height: 53px !important;
      border-radius: 50%;
      border: 6px solid rgba(255, 255, 255, 100);
      // }
    }
    .name {
      color: rgba(249, 247, 247, 100);
      font-size: 18px;
      text-align: left;
      height: 27px;
      line-height: 27px;
      font-family: SourceHanSansSC-bold;
    }
    .desc {
      color: rgba(153, 159, 164, 100);
      font-size: 12px;
      text-align: left;
      height: 18px;
      line-height: 18px;
      font-family: SourceHanSansSC-regular;
    }
    .mr7 {
      margin-right: 7px;
    }
    .tips1 {
      height: 28px;
      line-height: 28px;
      background-color: rgba(11, 110, 105, 100);
      margin-top: 23px;
      padding-right: 19px;
      box-sizing: border-box;
      img {
        width: 11px;
        height: 11px;
        margin-left: 34px;
        margin-right: 15px;
      }
    }
    .tips2 {
      height: 28px;
      line-height: 28px;
      background-color: rgba(28, 163, 130, 100);
      padding-right: 19px;
      box-sizing: border-box;
      img {
        width: 14px;
        height: 14px;
        margin-left: 32px;
        margin-right: 15px;
      }
    }
  }
  .block {
    width: 358px;
    border-radius: 2px;
    min-height: 64px;
    border: 1px solid rgba(255, 255, 255, 100);
    padding: 14px 10px 14px 8px;
    margin: 13px auto 3px;
    box-sizing: border-box;
    background: #fff;
    .userimg {
      width: 36px;
      height: 36px;
      border-radius: 50%;
      position: absolute;
      border: 2px solid rgba(237, 237, 237, 100);
      // top:0
    }
    .w220 {
      width: 200px;
      text-align: right;
    }
    .lh53 {
      line-height: 26px;
    }
    .logo {
      width: 82px;
      height: 24px;
    }
    .title {
      color: rgba(16, 16, 16, 100);
      font-size: 16px;
      text-align: left;
      line-height: 23px;
      height: 46px;
      font-family: SourceHanSansSC-regular;
      width: 204px;
      display: -webkit-box;
      -webkit-box-orient: vertical;
      -webkit-line-clamp: 2;
      overflow: hidden;
    }
    .poster {
      width: 112px;
      height: 78px;
      border-radius: 4px;
    }
    .btnr {
      width: 51px;
      height: 18px;
      line-height: 17px;
      border-radius: 100px;
      color: rgba(93, 199, 185, 100);
      font-size: 8px;
      text-align: center;
      font-family: Roboto;
      border: 1px solid rgba(93, 199, 185, 100);
    }
    .downs {
      width: 100%;
      height: 28px;
      line-height: 28px;
      img {
        width: 15px;
        height: 15px;
        margin-left: 5px;
      }
    }
  }
  .qrcode {
    width: 200px;
    height: 200px;
    margin: 0 auto;
    display: block;
  }
  .shareimg {
    width: 50%;
    float: right;
    margin-right: 10px;
  }
}
</style>